<template>
  <div id="experience">
    <section class="section" style="background: #FAFAFA;">
    <div style="width:100%;">
      <div class="has-text-centered">
        <span style="margin-bottom:30px" class="underline heading is-size-2 w300">Experience</span>
        <table style="margin:auto;">
          <tbody>
            <template v-for="exp in experiences">
              <tr class="tr-head has-text-weight-bold" :key="exp.id">
                <td style="" class="has-text-right td-work-place">{{ exp.company }}</td>
                <td style="" class="has-text-left td-work-place">{{ exp.position }}</td>
                
              </tr>
              <tr :key="exp.id">
                <td style="" class="has-text-right">
                  <span class="tag is-light-blue-green">{{ exp.period }}</span>
                </td>
                <td class="td-work">{{ exp.work }}</td>
              </tr>
              <tr :key="exp.id">
                <td>
                </td>
                <td class="td-link">
                  <a bind-href="exp.link"> {{ exp.link }} </a>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>        
    </div>   
  </section>
  </div>
</template>

<script>

import experiences_data from '../data/experience.json';
export default {
  data() {
    return {
      experiences:experiences_data
    }
  },
  methods:{
    getLevelColor(level){
      if(level == '3') return 'tag is-light-blue-green'      
      if(level == '2') return 'tag is-light-dark'
      if(level == '1') return 'tag is-lighter-dark'
    }
  }
}
</script>

<style scoped>

.tr-head {
  border-top: 1px solid rgb(226, 226, 226);
  line-height: 20px;
}

table tr:first-child {
  border: 0;
}

td {
  padding: 5px;
}

.td-work-place {
  padding: 20px 5px 5px 5px;
}

.td-work {
  max-width: 700px;
  padding: 5px 5px 5px 5px;
}

.td-link {
  max-width: 700px;
  padding: 0px 5px 20px 5px;
}

</style>
